export default "__VITE_ASSET__BD5kKkLz__"